export default "__VITE_ASSET__hgghoj7h__"